import React from "react";
import { AlternativeProduct } from "./InternalNotesResult";

interface Props {
  alternativeProducts: AlternativeProduct[];
  categoryPageLink: string;
}

const AlternativeProductSuggestions = ({
  alternativeProducts,
  categoryPageLink,
}: Props) => {
  return (
    <div data-testid="alternativeProductSuggestions">
      <h4>Alternative Product Suggestions</h4>
      {!alternativeProducts.length ? (
        <>
          <div>No clear alternative products to suggest.</div>
          <div>Try this item&apos;s category:</div>
          <div>
            <a
              href={categoryPageLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {categoryPageLink}
            </a>
          </div>
        </>
      ) : (
        <>
          {alternativeProducts.map((alternativeProduct) => (
            <div key={alternativeProduct.productLink}>
              <a
                href={alternativeProduct.productLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                {alternativeProduct.itemNumber}
              </a>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default AlternativeProductSuggestions;
